// Shared bounds for date inputs across deal-entry forms.
//
// Native <input type="date"> fields let users type an arbitrary year (e.g. a
// 5-digit "22222"), because without a `max` the browser allows up to 6 digits in
// the year segment. Constraining the inputs to a sane 4-digit range both caps the
// year segment length and lets us reject out-of-range values before they are saved.

export const DATE_INPUT_MIN = '1900-01-01';
export const DATE_INPUT_MAX = '2100-12-31';

// Date object equivalents, for libraries (e.g. react-datepicker) that expect Dates.
export const DATE_OBJ_MIN = new Date('1900-01-01');
export const DATE_OBJ_MAX = new Date('2100-12-31');

/** True when value is a YYYY-MM-DD string within the supported range. */
export function isDateInRange(value) {
  if (!value) return true; // empty is allowed; required-field checks live elsewhere
  // Reject anything that isn't exactly a 4-digit-year ISO date.
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  return value >= DATE_INPUT_MIN && value <= DATE_INPUT_MAX;
}

/**
 * Sanitize a raw <input type="date"> value: returns the value when it is a valid
 * in-range YYYY-MM-DD string, otherwise returns '' so out-of-range/garbage years
 * (like 22222) never make it into form state.
 */
export function sanitizeDateInputValue(value) {
  return isDateInRange(value) ? value : '';
}
